WiseMetering.Collection.ApiRequests = WiseMetering.Collection.extend({
    hasOrganization: true,
    url: '/api_requests',
    comparator: function(model) {
        return [model.get('integrator'), model.get('object_class'), model.get('action'), model.get('day')];
    }
});
